import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import Button from "@/app/components/UI/Button";
import React from "react";
interface VerificationCodeButtonProps {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}
export default function VerificationCodeButton(t0) {
  const $ = _c(6);
  const {
    children,
    onClick,
    disabled,
    loading,
    className
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== disabled || $[3] !== loading || $[4] !== onClick) {
    t1 = <Button variant="solid" color="primary" size="md" fullWidth={true} onClick={onClick} disabled={disabled} loading={loading} className={className}>{children}</Button>;
    $[0] = children;
    $[1] = className;
    $[2] = disabled;
    $[3] = loading;
    $[4] = onClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}